import React from 'react'
import {
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {LeftIcon, CloseIcon} from '../icons'
import {noop} from '../../utils/utils'
import DrawerSecondLevelContent from './drawer-second-level-content'

const DrawerMenuSecondLevel = ({
    selectedCategory = {},
    setSelectedCategory = noop,
    onClose = noop,
}) => {
    const styles = useMultiStyleConfig('BraunMenu', {})
    const drawerMenu = styles?.drawerMenu || {}
    const handleCloseModal = () => {
        setSelectedCategory(null)
        onClose()
    }
    const secondLevelTitle =
        selectedCategory?.second_level_categories?.[0]?.second_level_categories_title || ''
    return (
        <Flex {...drawerMenu?.secondLevelContainer}>
            <Flex {...drawerMenu?.secondLevelInnerContainer}>
                {/* Header */}
                <Flex {...drawerMenu?.headerContainer}>
                    <Flex {...drawerMenu?.goBackContainer}>
                        {/* Back button */}
                        <LeftIcon
                            {...drawerMenu?.goBackIcon}
                            onClick={() => setSelectedCategory(null)}
                        />

                        {/* Category title */}
                        <Text textStyle="head-xsmall" fontWeight="400" color="text.default">
                            {selectedCategory.title}
                        </Text>

                        {/* Close button */}
                        <Flex {...drawerMenu?.closeContainer} onClick={handleCloseModal}>
                            <CloseIcon w="iconsSize.small" h="iconsSize.small" color="white" />
                        </Flex>
                    </Flex>
                </Flex>
                <Flex w="100%" overflowY="auto">
                    <DrawerSecondLevelContent
                        second_level_categories={
                            selectedCategory?.second_level_categories?.[0]?.second_level_categories
                        }
                        first_level_image_section={selectedCategory?.first_level_image_section}
                        secondLevelTitle={secondLevelTitle}
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}

DrawerMenuSecondLevel.propTypes = {
    selectedCategory: PropTypes.object,
    setSelectedCategory: PropTypes.func,
    onClose: PropTypes.func,
}

export default DrawerMenuSecondLevel
